<template>
  <v-app>
    <div class="map-container" :class="{'isDrawer' : drawer}">
      <div id="map"></div>
      <v-btn
        flat 
        fab dark small
        color="primary"
        @click.stop="toggleMenu()"
        class="btn-toggle"
        v-if="vehicles.length"
      >
        <v-icon color="black" size="28">motorcycle</v-icon>
      </v-btn>
    </div>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      fixed
      app
      class="list-vehicle"
      right
      width="300"
      v-if="vehicles.length"
    >
      <v-text-field
        flat
        solo
        hide-details
        prepend-icon="search"
        placeholder="Tìm trên danh sách"
        class="pl-3 pr-5"
        v-model="keyword"
      ></v-text-field>
      <v-divider></v-divider>
        <v-list three-line>
          <template v-for="(item, index) in vehicles">
            <v-list-tile 
              :key="item.id"
              @click="selectedVehicle(item)"
            >
              <v-list-tile-avatar>
                <img :src="getVehicleIcon(item)">
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{item.plate}}</v-list-tile-title>
                <v-list-tile-sub-title>{{getVehicleStatus(item)}}</v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <v-icon small>location_on</v-icon>
                  {{getAddress(item)}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="item / 2 !== 0" :key="index*10000"></v-divider>
          </template>
      </v-list>
    </v-navigation-drawer>

    <v-dialog
      v-model="dialog"
      max-width="350"
      persistent
    >
      <v-card>
        <v-card-title class="headline text-xs-center">Chia sẻ lộ trình đã hết phiên sử dụng!</v-card-title>
        <v-card-actions class="justify-center pb-3">
          <v-btn
            color="primary"
            class="black--text"
            @click="goHome"
          >
              Về trang chủ
              &nbsp;
              <v-icon size="16">home</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import * as MapUtil from '@/utils/maputil';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import { mapActions, mapMutations } from 'vuex';

export default {
  data: () => ({
    drawer: true,
    items: [
      { title: 'Home', icon: 'dashboard' },
      { title: 'About', icon: 'question_answer' }
    ],
    mapType: 'roadmap',
    mapLayer: null,
    map: null,
    // Display
    display: {
      showGeofences: false,
      showPopup: true
    },
    vehicles: [],
    mini: false,
    keyword: '',
    dialog: false,
    interval: null,
    markers: [],
    test: '1234'
  }),
  watch: {
    keyword () {
      this.filterVerhicle();
    }
  },
  async mounted () {
    let res = await this.getDataSharingStates();
    if (res) {
      // eslint-disable-next-line
      this.map = L.map('map', {
        attributionControl: false,
        zoomControl: false
      }).setView(MapUtil.getLatLngFromWaypoint({ x: this.vehicles[0].x, y: this.vehicles[0].y }), MapUtil.MAP_CONFIG.zoom);
      this.mapLayer = MapUtil.createMapTileLayer(this.mapType);
      this.mapLayer.addTo(this.map);
      this.map.on('click', e => {
        this.display.showPopup = false;
      });
      this.drawMarker();
      console.log('this.dialog', this.dialog);
      this.setIntervalSharing();
    }
  },
  methods: {
    toggleMenu () {
      this.drawer = !this.drawer;
    },
    ...mapActions(['getVehicles', 'getVehicleWaypoints', 'getSharingStates']),
    getVehicleIcon: vehicles => MapUtil.getVehicleIcon({ waypoint: vehicles }),
    getVehicleStatus: vehicle => MapUtil.getVehicleStatus({ waypoint: vehicle }),
    getAddress (vehicle) {
      let address = 'Không xác định';
      if (vehicle && vehicle.data) {
        if (vehicle.data.addr !== undefined) {
          address = `${vehicle.data.addr},${
            vehicle.data.admin
          }`;
        } else {
          address = vehicle.data.admin;
        }
        address = address.split(',').join(', ');
      }
      return address;
    },

    async getDataSharingStates () {
      if (!this.$route.query.code) {
        this.reset();
        return false;
      }
      let param = {
        code: this.$route.query.code,
        uctTicks: 0
      };
      let result = await this.getSharingStates(param).catch(res => {
        this.reset();
        return false;
      });
      // if (!result || result.code === 'ERR_CODE_NOT_EXIST' || result.code === 'ERR_SHARING_STOP' || !result.data || !result.data.length) {
      if (!result || result.length < 1) {
        this.reset();
        return false;
      }
      this.vehicles = result;
      return true;
    },
    drawMarker () {
      console.log('this.vehicles', this.vehicles);
      this.clearMakerMap();
      if (this.vehicles && this.vehicles.length) {
        this.vehicles.forEach(item => {
          // eslint-disable-next-line
          let icon = L.icon({
            iconUrl: this.getVehicleIcon(item),
            iconSize: [50, 50],
          });
          // eslint-disable-next-line
          let marker = L.marker(MapUtil.getLatLngFromWaypoint({ x: item.x, y: item.y }), {
            icon: icon,
            rotationAngle: item.heading,
            rotationOrigin: 'center center'
          }).addTo(this.map);
          // eslint-disable-next-line
          marker.bindTooltip(item.plate, { direction: 'bottom', permanent: true, opacity: 1, offset: [0, 25] }).openTooltip();
          this.markers.push(marker);
        });
      }
    },
    async filterVerhicle () {
      await this.getDataSharingStates();
      if (this.keyword) {
        this.vehicles = this.vehicles.filter(i => (i.plate + this.getAddress(i)).includes(this.keyword));
      }
    },
    selectedVehicle (data) {
      let latlng = MapUtil.getLatLngFromWaypoint({ x: data.x, y: data.y });
      // eslint-disable-next-line
      this.map.panTo(MapUtil.getLatLngFromWaypoint({ x: data.x, y: data.y }));
    },
    goHome () {
      this.dialog = false;
      this.$router.push({ path: '/' });
    },
    setIntervalSharing () {
      this.interval = setInterval(() => {
        let res = this.getDataSharingStates();
        if (res) this.drawMarker();
      }, 10000);
    },
    clearMakerMap () {
      this.markers.forEach(i => {
        this.map.removeLayer(i);
      });
      this.markers = [];
    },
    reset () {
      this.dialog = true;
      this.drawer = false;
      if (this.interval) clearInterval(this.interval); 
      if (this.map) this.map.remove();
      this.vehicles = [];
    }
  }
};
</script>

<style scoped lang="css">
.map-container{
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  height: 100%;
}
.map-container.isDrawer{
  padding-right: 300px;
}
#map{
  width: 100%; 
  height: 100%;
  z-index: 1;
}
.btn-toggle{
  position: absolute !important;
  top: 0;
  right: 0;
  z-index: 400;
  background-color: #fff;
}
.list-vehicle{
  /* max-width: 400px;
  width: 100% !important; */
}
@media (max-width: 959px) {
  /* .map-container.isDrawer{
    padding-right: 240px;
  }
  .list-vehicle{
    max-width: 240px;
  } */
}
</style>



// WEBPACK FOOTER //
// src/pages/Sharing.vue